import { render, staticRenderFns } from "./newTrasladoL.vue?vue&type=template&id=1f4c776a&scoped=true"
import script from "./newTrasladoL.vue?vue&type=script&lang=js"
export * from "./newTrasladoL.vue?vue&type=script&lang=js"
import style0 from "./newTrasladoL.vue?vue&type=style&index=0&id=1f4c776a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c776a",
  null
  
)

export default component.exports